import { Injectable, NgZone } from '@angular/core';
import { Router } from '@angular/router';
import { AuthorisationService } from '../authorisation/authorisation.service';

@Injectable({
  providedIn: 'root',
})
export class InactivityService {
  private timeout: any;
  private readonly timeoutDuration =  5* 60 * 1000; // 5 minutes

  constructor(private router: Router, private ngZone: NgZone,private authorisationService: AuthorisationService) {
    this.startMonitoring();
  }

  startMonitoring() {
    this.resetTimeout();

    ['mousemove', 'keydown', 'click'].forEach((event) => {
      window.addEventListener(event, () => this.resetTimeout());
    });
  }

  resetTimeout() {
    clearTimeout(this.timeout);
    this.timeout = setTimeout(() => this.handleTimeout(), this.timeoutDuration);
  }

  handleTimeout() {
    // Optionally clear stored tokens
    // alert('Session expired. Please log in again.');
    // this.authorisationService.logoutExpireToken();
    // this.authorisationService.logout();
    this.router.navigate(['/logout']); // Redirect to login
  }
}
